import api from '../api';

import {
  enqueueErrorSnackbar,
  enqueueSuccessSnackbar,
  isSuccessfulStatus,
  joinWithComma,
  pluck
} from 'helpers/AppHelpers';

import {
  ERROR_UPDATE_ASSET_STATUS,
  SUCCESS_ADD_ASSET_TICKETS,
  SUCCESS_UPDATE_ASSETS_FIELDS,
  SUCCESS_UPDATE_ASSETS_STATUS,
  SUCCESS_UPDATE_ASSET_LOCATION,
  SUCCESS_DELETE_ASSET,
  TRY_AGAIN_MESSAGE
} from 'constants/infoSnackbarData';

import {
  CLEAR_BATCH_ASSET_UPDATES_STATE,
  SET_BATCH_ASSET_UPDATES_TAB,
  SET_BATCH_ASSET_UPDATES_CREATION_FORM
} from '../constants/reduceConstants';

export const getCreationForm = () => (dispatch) =>
  api.batchAssetUpdates
    .getCreationFormApi()
    .then((res) => dispatch({ type: SET_BATCH_ASSET_UPDATES_CREATION_FORM, payload: res || {} }))
    .catch((err) => console.log(err));

export const getLocationsByAssets = (query) => () =>
  api.batchAssetUpdates
    .getLocationsApi(query)
    .then((res) => res)
    .catch((err) => console.log(err));

export const getSublocations = (id) => () =>
  api.batchAssetUpdates
    .getSublocationsApi(id)
    .then((res) => res)
    .catch((err) => console.log(err));

export const getAssetFields = (q) => () =>
  api.batchAssetUpdates
    .getAssetFieldsApi(q)
    .then((res) => res)
    .catch((err) => console.log(err));

export const getTicketTypes = (query) => () =>
  api.batchAssetUpdates
    .getTicketTypesApi(query)
    .then((res) => res)
    .catch((err) => console.log(err));

export const getRootCauses = (query) => () =>
  api.batchAssetUpdates
    .getRootCausesApi(query)
    .then((res) => res)
    .catch((err) => console.log(err));

export const createTickets = (data) => () =>
  api.batchAssetUpdates
    .createTicketsApi(data)
    .then((res) => {
      enqueueSuccessSnackbar(SUCCESS_ADD_ASSET_TICKETS);
      return res;
    })
    .catch((err) => {
      const errors = err?.request?.response && JSON.parse(err.request.response);
      enqueueErrorSnackbar('', errors);
      return errors;
    });

export const assignAssetsToLocation = (data) => () =>
  api.batchAssetUpdates
    .assignAssetsToLocationApi(data)
    .then((res) => {
      enqueueSuccessSnackbar(SUCCESS_UPDATE_ASSET_LOCATION + ' ' + data?.location?.siteCode || '');
      return res;
    })
    .catch((err) => {
      const errors = err?.request?.response && JSON.parse(err.request.response);
      enqueueErrorSnackbar('', errors);
      return errors;
    });

export const updateAssetsStatus = (data) => () =>
  api.batchAssetUpdates
    .updateAssetsStatusApi(data)
    .then((res) => {
      const generateAssetString = (assetsArray, type, nameField) =>
        assetsArray
          .map(
            ({ assets, [nameField]: name }) =>
              `${type} ${name?.name || ''}: ${joinWithComma(pluck(assets, 'drCode'))}`
          )
          .join('\n');

      const showErrorPopup = (picklistAssets, assembledAssets) => {
        const picklistString = picklistAssets?.length
          ? '\n' + generateAssetString(picklistAssets, 'Picklist', 'picklist')
          : '';
        const assembleString = assembledAssets?.length
          ? '\n' + generateAssetString(assembledAssets, 'Assembly', 'assembledLooseItem')
          : '';

        enqueueErrorSnackbar(`${ERROR_UPDATE_ASSET_STATUS}${picklistString}${assembleString}`);
      };

      const showSuccessPopup = () => {
        enqueueSuccessSnackbar(
          SUCCESS_UPDATE_ASSETS_STATUS + ' ' + data?.rental?.rentalStatus?.displayName || ''
        );
      };

      const { assetsInPicklist, assetsInAssemble } = res.data || {};

      if (assetsInPicklist?.length || assetsInAssemble?.length) {
        showErrorPopup(assetsInPicklist, assetsInAssemble);
      } else {
        showSuccessPopup();
      }

      return res;
    })
    .catch((err) => {
      const errors = err?.request?.response && JSON.parse(err.request.response);
      enqueueErrorSnackbar('', errors);
      return errors;
    });

export const updateAssetFields = (data) => () =>
  api.batchAssetUpdates
    .updateFieldsApi(data)
    .then((res) => {
      if (isSuccessfulStatus(res.status)) {
        enqueueSuccessSnackbar(SUCCESS_UPDATE_ASSETS_FIELDS);
        return res;
      }
    })
    .catch((err) => {
      enqueueErrorSnackbar(TRY_AGAIN_MESSAGE);
      return err;
    });

export const deleteAssets = (data) => () =>
  api.batchAssetUpdates
    .deleteAssetsApi(data)
    .then((res) => {
      enqueueSuccessSnackbar(SUCCESS_DELETE_ASSET);
      return res;
    })
    .catch((err) => {
      enqueueErrorSnackbar(TRY_AGAIN_MESSAGE);
      return err;
    });

export const setTab = (payload) => (dispatch) =>
  dispatch({ type: SET_BATCH_ASSET_UPDATES_TAB, payload });

export const clearState = (formValues) => (dispatch) =>
  dispatch({ type: CLEAR_BATCH_ASSET_UPDATES_STATE, payload: formValues });
